import { Component, OnInit, Input, OnChanges, OnDestroy, ElementRef, HostListener } from '@angular/core';
import { FormGroup, FormControl, Validators } from '@angular/forms';
import { EventsService } from 'src/app/services/events-service/events.service';
import { UserStorageService } from 'src/app/services/user-storage-service/user-storage.service';
import { SnackBarService } from 'src/app/components/shared-components/snack-bar/snack-bar.service';
import { EMPTY, Subscription } from 'rxjs';
import { tap } from 'rxjs/internal/operators/tap';
import { catchError } from 'rxjs/internal/operators/catchError';

@Component({
  selector: 'app-events-event-info-card',
  templateUrl: './events-event-info-card.component.html',
  styleUrls: ['./events-event-info-card.component.scss']
})
export class EventsEventInfoCardComponent implements OnInit, OnChanges, OnDestroy {

  @Input() alert;
  @Input() centerList;
  editingLocked: boolean;
  basicDataForm = new FormGroup({
    active: new FormControl({value: null, disabled: true}, Validators.required),
    name: new FormControl({value: null, disabled: true}, Validators.required),
    selectedCenter: new FormControl({value: null, disabled: true}, Validators.required)
  });
  refreshAlertListenSubscription: Subscription;
  getAlertApplicationsSubscription: Subscription;
  getCompanyMailProvidersSubscription: Subscription;
  updateAlertSubscription: Subscription;

  constructor(private eventsService: EventsService,
              private userStorageService: UserStorageService,
              private snackbarService: SnackBarService,
              private eRef: ElementRef) {
                this.editingLocked = true;
              }

  ngOnInit() {
    this.centerList = this.userStorageService.getCenterList();
    this.refreshAlertListenSubscription = this.eventsService.refreshAlertListen().subscribe(
      (res) => {
        this.resetForm();
      }
    );
  }

  ngOnChanges() {
    if (this.alert && this.centerList) {
      this.resetForm();
    }
  }

  @HostListener('document:click', ['$event'])
  clickout(event) {
    if (this.eRef.nativeElement.contains(event.target)) {
    } else {
      if (event.path && event.path[0].className !== 'mat-option-text') {
        if (this.alert && !this.editingLocked) {
          this.resetForm();
          this.lockEdition();
        }
      }
    }
  }

  public submitForm() {
    this.updateAlertSubscription = this.eventsService.updateAlertInfo(this.alert.InternalId, this.basicDataForm.get('active').value, this.basicDataForm.get('name').value, this.getSelectedCenterInternalId()).pipe(
      tap(o => this.lockEdition()),
      tap(o => this.eventsService.refreshAlert()),
      tap(o => this.snackbarService.open(o['data']['message'], 'success')),
      catchError(error => { this.snackbarService.open(error['error']['message'], 'error'); return EMPTY; })
    ).subscribe();
  }

  public toggleEdition() {
    if (this.editingLocked) {
      this.unlockEdition();
    } else {
      const validation = this.validateForm();
      if (validation === true) {
        this.submitForm();
      } else {
        this.snackbarService.open(validation, 'error');
      }
    }
  }



  public validateForm() {
    if (!this.basicDataForm.get('name').valid) {
      return 'events-page.snackbar messages.event name required error';
    } else if (!this.basicDataForm.get('selectedCenter').valid) {
      return 'events-page.snackbar messages.selected center required error';
    } else {
      return true;
    }
  }

  public resetForm() {
    this.basicDataForm.patchValue({
      active: this.alert.Active,
      name: this.alert.AlertName,
      selectedCenter: this.setSelectedCenter(),
    });
  }

  public unlockEdition() {
    this.basicDataForm.get('active').enable();
    this.basicDataForm.get('name').enable();
    this.basicDataForm.get('selectedCenter').enable();
    this.editingLocked = false;
  }

  public lockEdition() {
    this.basicDataForm.get('active').disable();
    this.basicDataForm.get('name').disable();
    this.basicDataForm.get('selectedCenter').disable();
    this.editingLocked = true;
  }

  public setSelectedCenter() {
    if (this.alert && this.centerList && this.centerList.length > 0) {
      for (const center of this.centerList) {
        if (center.InternalId === this.alert.CenterInternalId) {
          return center;
        }
      }
    } else {
      return null;
    }
  }

  public getSelectedCenterInternalId() {
    if (this.centerList.length === 1) {
      return this.centerList[0].InternalId;
    } else {
      if (this.basicDataForm.get('selectedCenter').value) {
        return this.basicDataForm.get('selectedCenter').value.InternalId;
      } else {
        return null;
      }
    }
  }

  public setPreselected(op1, op2) {
    if (op1 && op2) {
      return op1.InternalId === op2.InternalId;
    }
  }

  ngOnDestroy() {
    if (this.refreshAlertListenSubscription) { this.refreshAlertListenSubscription.unsubscribe(); }
    if (this.getAlertApplicationsSubscription) { this.getAlertApplicationsSubscription.unsubscribe(); }
    if (this.getCompanyMailProvidersSubscription) { this.getCompanyMailProvidersSubscription.unsubscribe(); }
    if (this.updateAlertSubscription) { this.updateAlertSubscription.unsubscribe(); }
  }
}
